import { getPathWithArgs, pathgen } from 'object-path-generator';
export const getTestIds = parentTestId => {
  return pathgen(undefined, function (path) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    const testId = getPathWithArgs(path, args);
    if (parentTestId) {
      return "".concat(parentTestId, " > ").concat(testId);
    }
    return testId;
  });
};